import { Injectable } from '@angular/core';
import { EntityManagerProvider } from '../entity-manager-provider/entity-manager-provider';
import { allSettled } from 'q';
import { Constantes } from '../../domain/constantes';
import { NodoFormulario } from '../../domain/NodoFormulario';
import { SeccionPlano } from 'interiores-mapa';

@Injectable()
export class DiagnosticoService {

  	constructor(
		public EM: EntityManagerProvider
	){

	}

	ERROR_CONTENIDO_SIN_NODO = 1;
	ERROR_CONTENIDO_SIN_SECCION = 2;
	ERROR_CONTENIDO_SIN_NODO_has_CONTENIDO = 3;
	ERROR_CONTENIDO_SIN_SECCION_has_CONTENIDO = 4;


	public repararContenidos(){
		const that = this;
		this.limpiar('BreezeBody');

		let contenidosTodos;
		let seccionesTodas;
		let seccionPorDefecto;

		let includes = 'ALA, ';
		includes = includes + 'CONTENIDOS.CONTENIDO, ';
		includes = includes + 'NODOS';

		return this.EM.getSECCION(undefined, includes)
		.then(function (secciones){
			seccionesTodas = secciones;

			includes = 'ALAS.ALA, ';
			includes = includes + 'ESPACIOS.ESPACIO, ';
			includes = includes + ' NIVELES.NIVEL, ';
			includes = includes + 'NODODS.NODO, ';
			includes = includes + 'SECCIONES.SECCION';

			return that.EM.getCONTENIDO(undefined, includes);
		})
		.then(function (contenidos){
			contenidosTodos = contenidos;

			const promises: any[] = [];

			for (let index = 0; index < contenidos.length; index++) {
				let error = 0;
				const contenido = contenidos[index];

				console.log('Contenido: ' + contenido.Titulo );
				if (contenido.Titulo === 'contenido2') {
					const a = 1;
				}

				if (contenido.SECCIONES.length === 0) {
					error = that.ERROR_CONTENIDO_SIN_SECCION_has_CONTENIDO;
				}
				else if (contenido.SECCIONES[0].SECCION === null){
					error = that.ERROR_CONTENIDO_SIN_SECCION;
				}

				if (contenido.NODODS.length === 0) {
					error = that.ERROR_CONTENIDO_SIN_NODO_has_CONTENIDO;
				}
				else if (contenido.NODODS[0].NODO === null){
					error = that.ERROR_CONTENIDO_SIN_NODO;
				}

				if (contenido.IdAlaPlano){
					seccionesTodas.forEach(seccion => {
						if (seccion.ALA.Id === contenido.IdAlaPlano && seccion.Nombre === 'Default') {
							seccionPorDefecto = seccion;
						}
						else if (seccion.Nombre === 'Default'){
							seccionPorDefecto = seccion;
						}
					});
				}


				that.repararContenido(contenido, seccionPorDefecto, seccionesTodas);

				that.escribir(1, '.', 'BreezeBody');
			}

			return allSettled(promises);
		})
		.then(function (contenidos){
			return that.EM.saveChanges();
		});
	}

	public repararNodo(Nodo, seccionDefecto, sections) {

		let seccionDetectada;

		this.escribir(1, 'NODO: ' + Nodo.Nombre, 'BreezeBody');
		this.escribir(1, '-------------------------------------------', 'BreezeBody');
		this.escribir(1, '.', 'BreezeBody');

		// const contentPlano = this.mapContents.get(contenido.id);
		console.log(Nodo.X + ' , ' + Nodo.Y);


		//  Calcular la nueva seccion...
		seccionDetectada = seccionDefecto;
		sections.forEach((seccionPlano: SeccionPlano) => {
			if (seccionPlano.getCoordenadasPoligono()) {
				if (this.pointInPolygon([Nodo.X as number, Nodo.Y as number], seccionPlano.getCoordenadasPoligono())) {
					seccionDetectada = seccionPlano.ENTIDAD;
				}
			}
		});

		Nodo.IdSeccion = seccionDetectada.Id;
		Nodo.NombreSeccion = seccionDetectada.Nombre;

		return this.EM.saveChanges();
	}

	public repararContenido(contenido, seccionDefecto, sections) {

		let seccionDetectada;
		let nodosSeccionDetectada;
		let distanciaMinima = Constantes.MAX_PESO;
		let nodoMasCercano;

		this.escribir(1, 'CONTENIDO: ' + contenido.Titulo, 'BreezeBody');
		this.escribir(1, '-------------------------------------------', 'BreezeBody');
		this.escribir(1, '.', 'BreezeBody');

		// const contentPlano = this.mapContents.get(contenido.id);
		console.log(contenido.X + ' , ' + contenido.Y);

		//  Calcular la nueva seccion...
		seccionDetectada = seccionDefecto;
		sections.forEach((seccion) => {

			if (contenido.IdAlaPlano && seccion.ALA.Id === contenido.IdAlaPlano){
				if (seccion.CoordenadasPoligono) {
					if (this.pointInPolygon([contenido.X as number, contenido.Y as number], JSON.parse(seccion.CoordenadasPoligono))) {
						seccionDetectada = seccion;
					}
				}
			}

		});

		nodosSeccionDetectada = seccionDetectada ? seccionDetectada.NODOS : [];
		// d = sqrt( (x2 - x1)^2 + (y2 - y1)^2 )
		nodosSeccionDetectada.forEach(nodo => {
			const x1 = nodo.X;
			const y1 = nodo.Y;
			const x2 = contenido.X;
			const y2 = contenido.Y;

			const d = Math.sqrt( Math.pow((x2 - x1), 2) + Math.pow((y2 - y1), 2) );
			console.log('--- Distancia a: ' + nodo.Nombre + ' = ' + d);

			if (d < distanciaMinima) {
				distanciaMinima = d;
				nodoMasCercano = nodo;
			}
		});

		if (seccionDetectada && nodoMasCercano) {

			console.log('Seccion Seleccionada:  ' + seccionDetectada.Nombre);
			if (contenido.SECCIONES.length > 0) {

				if (contenido.NODODS.length > 0) {
					// Cogemos la seccion que fue asignada al posicionar el contenido por medio del nodo
					const nodoAntiguo = contenido.NODODS[0].NODO;
					const seccionAntigua = nodoAntiguo.SECCION;
					// Filtrar de las secciones asignadas al contenido la seccionAntigua y cambio la seccion
					const seccion_aux = contenido.SECCIONES.filter( s => s.IdSeccion === seccionAntigua.Id)[0];

					if (seccion_aux) {
						seccion_aux.SECCION = seccionDetectada;
					}
					else{
						// Si no existia relacion con la seccion anterior asumimos que la numero 0 es la asignada por posicionamiento
						contenido.SECCIONES[0].SECCION = seccionDetectada;
					}
				}
				else{
					console.error('No NODO_has_CONTENIDO Detectada -> Contenido: ' + contenido.nombre);
				}

			}
			else{
				console.log('SECCION Seccion_hasContenido -> Contenido: ' + contenido.nombre);
				this.crearRelacionSeccion_has_Contenido(contenido, seccionDetectada)
				.then(function(SECCION_has_CONTENIDO){
					console.log('SECCION_has_CONTENIDO Creada -> Contenido: ' + contenido.nombre);
				});
			}

			console.log('Nodo mas Cercano:  ' + nodoMasCercano.Nombre);
			if (contenido.NODODS.length > 0) {
				contenido.NODODS[0].NODO = nodoMasCercano;
			}
			else{
				console.log('NODO no Asignado -> Contenido: ' + contenido.nombre);
				this.crearRelacionNodo_has_Contenido(contenido, nodoMasCercano)
				.then(function(NODO_has_CONTENIDO){
					console.log('NODO_has_CONTENIDO Creado -> Contenido: ' + contenido.nombre);
				});
			}
		}
		else{
			if (!seccionDetectada) {
				console.error('No seccionDetectada -> Contenido: ' + contenido.nombre);
			}
			if (!nodoMasCercano) {
				console.error('No nodoMasCercano -> Contenido: ' + contenido.nombre);
			}
		}
	}

	crearRelacionSeccion_has_Contenido(contenido, seccionDetectada){
		const that = this;
		return this.EM.newSECCION_has_CONTENIDO()
		.then(function(SECCION_has_CONTENIDO){
			const element = SECCION_has_CONTENIDO;
			element.CONTENIDO = contenido;
			element.IdContenido = contenido.Id;
			element.SECCION = seccionDetectada;
			element.IdSeccion = seccionDetectada.Id;
			element.Prioridad = 0;
			element.PrioridadDestacado = 0;

			return element;
		});
	}

	crearRelacionNodo_has_Contenido(contenido, nodoMasCercano){
		const that = this;
		return this.EM.newNODO_has_CONTENIDO()
		.then(function(NODO_has_CONTENIDO){
			const element = NODO_has_CONTENIDO;
			element.CONTENIDO = contenido;
			element.IdContenido = contenido.Id;
			element.NODO = nodoMasCercano;
			element.IdNodo = nodoMasCercano.Id;

			return element;
		});
	}

	public pintarDiagnosticoCONTENIDOs(){
		const that = this;
		this.limpiar('BreezeBody');

		let contenidosTodos;
		let seccionesTodas;
		let seccionPorDefecto;

		let includes = 'ALA, ';
		includes = includes + 'CONTENIDOS.CONTENIDO, ';
		includes = includes + 'NODOS';

		return this.EM.getSECCION(undefined, includes)
		.then(function (secciones){
			seccionesTodas = secciones;

			includes = 'ALAS.ALA, ';
			includes = includes + 'ESPACIOS.ESPACIO, ';
			includes = includes + ' NIVELES.NIVEL, ';
			includes = includes + 'NODODS.NODO, ';
			includes = includes + 'SECCIONES.SECCION';

			return that.EM.getCONTENIDO(undefined, includes);
		})
		.then(function (contenidos){
			contenidosTodos = contenidos;

			const promises: any[] = [];

			for (let index = 0; index < contenidos.length; index++) {
				let error = false;
				const contenido = contenidos[index];

				that.escribir(1, 'CONTENIDO: ' + contenido.Titulo, 'BreezeBody');
				that.escribir(1, '-------------------------------------------', 'BreezeBody');
				that.escribir(1, '.', 'BreezeBody');

				if (contenido.SECCIONES.length === 0) {
					that.escribirError(2, ' -- CONTENIDO ERROR: ' + contenido.Titulo , 'BreezeBody');
					that.escribirError(3, ' -- No Existe SECCION_has_CONTENIDO', 'BreezeBody');
					error = true;
				}
				else if (contenido.SECCIONES[0].SECCION === null){
					that.escribirError(2, ' -- CONTENIDO ERROR: ' + contenido.Titulo , 'BreezeBody');
					that.escribirError(3, ' -- No Existe SECCION: ' + contenido.SECCIONES[0].IdSeccion , 'BreezeBody');
					error = true;
				}

				if (contenido.NODODS.length === 0) {
					that.escribirError(2, ' -- CONTENIDO ERROR: ' + contenido.Titulo , 'BreezeBody');
					that.escribirError(3, ' -- No Existe NODO_has_CONTENIDO', 'BreezeBody');
					error = true;
				}
				else if (contenido.NODODS[0].NODO === null){
					that.escribirError(2, ' -- CONTENIDO ERROR: ' + contenido.Titulo , 'BreezeBody');
					that.escribirError(3, ' -- No Existe NODO: ' + contenido.NODODS[0].IdNodo , 'BreezeBody');
					error = true;
				}

				if (!error) {
					that.escribir(2, 'OK!: ', 'BreezeBody');
				}

				if (contenido.IdAlaPlano){
					// TODO: Sacar Seccion por defecto
					seccionPorDefecto = {};
				}

				that.escribir(1, '.', 'BreezeBody');
			}

			return allSettled(promises);
		})
		.then(function (contenidos){
			return true;
		});
	}

	public pintarDiagnosticoCONEXIONES_NODOs() {
		const that = this;
		this.limpiar('BreezeBody');

		const entityManager = that.EM;
		//  const includes = 'SECCIONS, SECCIONS.NODOS, SECCIONS.NODOS.CONEXIONS_NODOS_ORIGEN, SECCIONS.NODOS.CONEXIONS_NODOS_DESTINO';
		// let includes = 'SECCIONS.NODOS.CONEXIONS_NODOS_ORIGEN.PESO_CONEXIONS, SECCIONS.NODOS.CONEXIONS_NODOS_DESTINO.PESO_CONEXIONS';
		const includes = 'CONEXIONS_NODOS_ORIGEN.PESO_CONEXIONS, CONEXIONS_NODOS_DESTINO.PESO_CONEXIONS';

		return entityManager.getNODO(undefined, includes)
		.then(function (nodos) {
			if (nodos == null || nodos.length < 1) {
				console.log('NO HAY NODOS');
			}
			else {

				// Pintar nodo con sus conexiones de ida y vuelta
				nodos.forEach(ENTIDAD => {
					// Imprimimos nombre del nodo
					that.escribir(1, 'NODO: ' + ENTIDAD.Nombre, 'BreezeBody');
					that.escribir(1, '-------------------------------------------', 'BreezeBody');
					that.escribir(1, '.', 'BreezeBody');

					if (ENTIDAD.CONEXIONS_NODOS_DESTINO.length === ENTIDAD.CONEXIONS_NODOS_ORIGEN.length) {
						that.escribir(2, 'OK!: ', 'BreezeBody');
					}
					else{
						// Contamos elementos ENTIDAD.CONEXIONS_NODOS_DESTINO
						that.escribirError(2, 'Destinos: ' + ENTIDAD.CONEXIONS_NODOS_DESTINO.length, 'BreezeBody');

						// Contamos elementos ENTIDAD.CONEXIONS_NODOS_ORIGEN
						that.escribirError(2, 'Origenes: ' + ENTIDAD.CONEXIONS_NODOS_ORIGEN.length, 'BreezeBody');
						that.escribir(1, '.', 'BreezeBody');
						// Imprimimos ENTIDAD.CONEXIONS_NODOS_DESTINO
						ENTIDAD.CONEXIONS_NODOS_DESTINO.forEach(elemento => {
							that.escribir(2, (elemento.NodoOrigen ? elemento.NodoOrigen.Nombre : '0000-0000-0000-0000') + ' ---> ' + (elemento.NodoDestino ? elemento.NodoDestino.Nombre : '0000-0000-0000-0000') +  ' [  ' + elemento.Id + '  ]', 'BreezeBody');
						});
						that.escribir(1, '.', 'BreezeBody');

						// Imprimimos ENTIDAD.CONEXIONS_NODOS_ORIGEN
						ENTIDAD.CONEXIONS_NODOS_ORIGEN.forEach(elemento => {
							that.escribir(2, (elemento.NodoDestino ? elemento.NodoDestino.Nombre : '0000-0000-0000-0000') + ' <--- ' + (elemento.NodoOrigen ? elemento.NodoOrigen.Nombre : '0000-0000-0000-0000') +  ' [  ' + elemento.Id + '  ]', 'BreezeBody');
						});
					}
					that.escribir(1, '.', 'BreezeBody');
					that.escribir(1, '.', 'BreezeBody');
				});
			}
			return true;
		});
	}

	public urlParam (name)
	{
		const results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
		if (results == null) {
			return null;
		}
		else {
			return decodeURI(results[1]) || 0;
		}
	}

  	public escribir(nivel, mensaje, childName) {

		const child = document.getElementById(childName);
		const span = document.createElement('span');

		span.innerText += mensaje;
		span.style.display = 'block';
		span.style.background = 'white';
		span.style.color = '#999';
		span.style.paddingLeft = (nivel * 20) + 'px';
		span.style.transition = '0.3s ease all';
		// span.style.borderBottom = '1px solid #DDD';

		child.appendChild(span);
		// child.innerText += ('<span style="' + styles + '">' + mensaje + '</span>');
	}

	public escribirError(nivel, mensaje, childName) {

		const child = document.getElementById(childName);
		const span = document.createElement('span');

		span.innerText += mensaje;
		span.style.display = 'block';
		span.style.background = 'white';
		span.style.color = '#900';
		span.style.paddingLeft = (nivel * 20) + 'px';
		span.style.transition = '0.3s ease all';
		// span.style.borderBottom = '1px solid #DDD';

		child.appendChild(span);
		// child.innerText += ('<span style="' + styles + '">' + mensaje + '</span>');
	}

	public limpiar(childName){
		const child = document.getElementById(childName);
		child.innerText = '';
	}

	public pointInPolygon(point: number[], polygon: number[][]): boolean {
        let inside = false;

        const x = point[0], y = point[1];
		for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
			const xi = polygon[i][0], yi = polygon[i][1], xj = polygon[j][0], yj = polygon[j][1];
			const intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
			if (intersect) { inside = !inside; }
		}

        return inside;
	}


}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/providers/diagnostico/diagnostico.service.ts